import { shopTitle } from "./nsdFields";
import "./events.css";

/**
 * Shop contact details for the screens where a guest can't complete what they
 * came to do. Falls back to the locations page when no shop is available, which
 * happens when the event itself couldn't be resolved.
 */
const ContactCard = ({ shop, label = "Please contact" }) => {
  if (!shop || (!shop.name && !shop.phone)) {
    return (
      <p className="ev-lead ev-contact-generic">
        To find your nearest location, visit{" "}
        <a
          href="https://www.cbac.com/locations/"
          target="_blank"
          rel="noopener noreferrer"
        >
          cbac.com/locations
        </a>
        .
      </p>
    );
  }

  return (
    <div className="ev-contact-card">
      <div className="ev-contact-label">{label}</div>
      {shop.name && (
        <div className="ev-contact-name">{shopTitle(shop.name)}</div>
      )}
      {shop.phone && (
        <a className="ev-contact-phone" href={`tel:${shop.phone}`}>
          {shop.phone}
        </a>
      )}
      {shop.address && <div className="ev-contact-address">{shop.address}</div>}
    </div>
  );
};

export default ContactCard;
